import React from "react";
import Footer from "../../components/footer/Footer";
import MainTemplate from "../Templates/MainTemplate";
import style from "./Main.module.css";
import MainSection from "./MainSection";
import OverDivComponent from "./components/OverDivComponent";
import Section from "./Section";
import { sectionMainPageList } from "../../util/CollectionData";
const Main = () => {
  const bodyContent = (
    <div className={style["main-container"]}>
      {sectionMainPageList.map((item, index) => (
        <div
          key={index}
          className={style["relative-container"]}
          style={{
            backgroundImage: `url(${item.backgroundImg})`,
          }}
        >
          <Section overlays={item.overlayList} />
          <div className={style["joker-info-container"]}>
            <OverDivComponent
              title={item.title}
              description={item.description}
              downloadLink={item.downloadLink}
              learnMoreLink={item.learnLink}
            />
          </div>
        </div>
      ))}
    </div>
  );

  return (
    <MainTemplate
      header={<MainSection />}
      body={bodyContent}
      footer={<Footer />}
      fullWidthHeader
      backgroundStyle={{ overflowX: "hidden" }}
    />
  );
};

export default Main;
